

export const soraFAQ = {
    title: 'Sora 2 常见问题',
    sub: '深入了解使用 Sora 2 生成专业视频的方方面面：功能与能力、最佳实践与操作建议。',
    items: [
      { num: '01', q: '什么是 Sora 2？与其他视频生成器有何差异？', a: 'Sora 2 是 OpenAI 最新的 AI 视频生成模型，在世界模拟与物理一致性上有突破性表现。可从文字提示或参考图片生成具电影质感的视频。' },
      { num: '02', q: 'Sora 2 的关键功能有哪些？', a: '双模式生成（文字转视频、图片转视频）、先进物理模拟、灵活长宽比、最高 15 秒的高清输出，以及对场景与风格的精准创作控制。' },
      { num: '03', q: '生成视频需要多少时间？', a: '依设置而异。标准 10 秒高清视频一般需 3–5 分钟；15 秒高清更久。输出包含原生音频。' },
      { num: '04', q: '为何我的生成经常失败？', a: '多因内容政策违规。请避免不允许内容，并使用清晰、具描述性的提示词以提高成功率。' },
      { num: '05', q: 'Sora 2 如何处理视频中的物理与真实感？', a: 'Sora 2 在物理准确性与真实感上表现优异，能处理浮力、重力与表面动态，保持运动一致性。' },
      { num: '06', q: '可否用于社媒与商业内容？', a: '可以。Sora 2 非常适合社媒与商业项目。输出无水印，并为 TikTok、Instagram、YouTube 等平台优化。' },
      { num: '07', q: '与早期模型相比，Sora 2 的提示遵从度如何？', a: '多镜头情境下仍能保持视觉与叙事一致性，提示遵从度更佳。提升的可控性便于达成精准的创作效果。' },
      { num: '08', q: '费用如何？积分系统怎么运作？', a: '采用透明的积分制按次计费。依需求购买即可，无需订阅。' }
    ],
    cta: '还有关于 Sora 2 的问题？',
    contact: '联系支持团队'
  };
